module.exports = __webpack_public_path__ + "img/37857-159.63829c7b.jpg";